import { App as AntdApp, ConfigProvider, ThemeConfig } from "antd";
import zhCN from "antd/locale/zh_CN";
import { useEffect } from "react";

import { RouterProvider } from "@tanstack/react-router";
import { router } from "@/router/router";
import { fetchEnumOptions } from "@/stores/enumOptionsStore";

const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: "#FF593E",
    colorLink: "#FF593E",
    borderRadius: 4,
    borderRadiusLG: 8,
    borderRadiusSM: 6,
    borderRadiusXS: 4,
  },
};

export const App = () => {
  useEffect(() => {
    fetchEnumOptions();
  }, []);

  return (
    <ConfigProvider
      locale={zhCN}
      theme={antdTheme}
      getPopupContainer={() => document.querySelector("#root") as HTMLElement}
      getTargetContainer={() => document.querySelector("#root") as HTMLElement}
    >
      <AntdApp>
        <RouterProvider router={router} />
      </AntdApp>
    </ConfigProvider>
  );
};
